import { apiConstants } from "../_constants";
import { authHeader, handleResponse } from "../_helpers";
export const subscriptionService = {
    subscriptionAdd,
    subscriptionList,
    subscriptionDelete,
};

function subscriptionAdd(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(apiConstants.apiUrl + "/addsubscription", requestOptions).then(
        handleResponse
    );
}
function subscriptionList(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(
        apiConstants.apiUrl + "/getsubscriptionList",
        requestOptions
    ).then(handleResponse);
}
function subscriptionDelete(data) {
    const requestOptions = {
        method: "POST",
        headers: authHeader(),
        body: JSON.stringify(data),
    };
    return fetch(
        apiConstants.apiUrl + "/deletesubscription",
        requestOptions
    ).then(handleResponse);
}
